import { useState } from "react";
import { confirmDialog } from "primereact/confirmdialog";

// The markings on the photos of the vehicle: add (with the option selector), move, remove.
// Adding a marking (Beri Tanda) only stages it locally: it has no id, so it does not exist on the server until the
// Save button of its photo card sends it (saveDetilMany).
const useEditorMarking = ({
  headerData,
  pengecekanData,
  pengecekanDetilData,
  setPengecekanDetilData,
  deleteDetil,
}) => {
  // dialog state
  const [showPengecekanMobilOptionDialog, setShowPengecekanMobilOptionDialog] =
    useState(false);
  const [optionSelectorAdditionalFilter, setOptionSelectorAdditionalFilter] =
    useState("");
  const [pengecekanMobilOptionDialogData, setPengecekanMobilOptionDialogData] =
    useState({});

  // handle UI event section

  const handleOnClickAddMarking = ({ field }) => {
    // the options of the trailer photos (gambar_box_*) belong to the trado / trailer jenis (16, 17)
    const kendaraanJenisFilter = field.startsWith("gambar_box_")
      ? "in:16,17"
      : "notin:16,17";
    setOptionSelectorAdditionalFilter(
      `label_grup:=:${field};kendaraan_jenis_id:${kendaraanJenisFilter}`
    );
    setPengecekanMobilOptionDialogData({ label_grup: field });
    setShowPengecekanMobilOptionDialog(true);
  };

  const handleOnChangeKordinat = ({ id, marking_kordinat }) => {
    setPengecekanDetilData(
      pengecekanDetilData.map((detil) => {
        // a marking not saved yet (staged by Beri Tanda) has no id: it is matched by _localId instead
        if ((detil.id || detil._localId) === id) {
          return { ...detil, marking_kordinat };
        }
        return detil;
      })
    );
  };

  const handleOnConfirmPengecekanMobilOption = (e, option) => {
    if (!option || option.length === 0) return;

    const singleOption = option[0];
    const { label_grup } = pengecekanMobilOptionDialogData;

    setShowPengecekanMobilOptionDialog(false);

    // pengecekanData is undefined until the header loads, so this can run before it exists
    const gambar = pengecekanData?.[label_grup];

    // new urutan: the highest urutan of the group + 1
    const _detailList = pengecekanDetilData.filter(
      (detil) => detil.label_grup === singleOption.label_grup
    );
    let urutan = 1;
    if (_detailList.length > 0) {
      urutan = Math.max(..._detailList.map((d) => d.urutan)) + 1;
    }

    const _newDetil = {
      // client-only: identifies this row until it is saved and gets a real id (see mergeSavedDetils)
      _localId: `new-${Date.now()}-${Math.random().toString(36).slice(2)}`,
      audit_kendaraan_id: headerData.id,
      pengecekan_mobil_option_id: singleOption.id,
      urutan,
      keterangan: singleOption.keterangan,
      cek: 0,
      label_grup: singleOption.label_grup,
      gambar,
      marking_warna: "rgb(225,29,72)",
      marking_kordinat: "0.5,0.5",
    };

    setPengecekanDetilData([...pengecekanDetilData, _newDetil]);
  };

  const handleOnClickRemoveMarking = async ({ data }) => {
    confirmDialog({
      message: `Menghapus penanda nomor #${data.urutan}, lanjutkan?`,
      header: "Konfirmasi Hapus",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: () => {
        if (data.id) {
          deleteDetil({ id: data.id });
        } else {
          // never saved (staged by Beri Tanda): just drop it locally, nothing to delete on the server
          setPengecekanDetilData(
            pengecekanDetilData.filter(
              (detil) => detil._localId !== data._localId
            )
          );
        }
      },
    });
  };

  return {
    showPengecekanMobilOptionDialog,
    setShowPengecekanMobilOptionDialog,
    optionSelectorAdditionalFilter,
    pengecekanMobilOptionDialogData,
    handleOnClickAddMarking,
    handleOnChangeKordinat,
    handleOnConfirmPengecekanMobilOption,
    handleOnClickRemoveMarking,
  };
};

export default useEditorMarking;
